export interface ICatalogObjectDisplayObject {
  id : string;
  name: string;
  collectionName : string;
  imageURL : string[];
  url: string;
  tags : Array<unknown>;
  height : string;
  width : string;
  displayPriority: string;
}

export class CatalogObjectDisplayObject
implements ICatalogObjectDisplayObject {
  id: string = '';
  name: string = '';
  price: string = '';
  collectionName: string = '';
  imageURL: string[] = [];
  url: string = '';
  tags: unknown[] = [];
  height: string = '';
  width: string = '';
  displayPriority: string = '';
}
